import React, { Fragment, useState } from "react";
import PropTypes from "prop-types";
import { Alert } from "reactstrap";
import { Formik, Form, Field } from "formik";
import TextInput from "./TextInput";
import Button from "./CustomButton";
import { faPowerOff } from "@fortawesome/fontawesome-free-solid";
import FontAwesomeIcon from "@fortawesome/react-fontawesome";
import NextForm from "../containers/NextForm";
import { setDisplayName, compose } from "recompose";

function formatPhone(phoneNumber) {
  if (!phoneNumber.includes("@")) {
    var extractNumbers = ("" + phoneNumber).replace(/\D/g, "");
    var number = extractNumbers.match(/^(\d{3})(\d{3})(\d{4})$/);
    if (number) {
      return number[1] + number[2] + number[3];
    }
  } else {
    return phoneNumber;
  }
}

export const LoginForm = props => {
  const { onSubmit, authenticating, failAuth, inputs, focusNextField, initialValues, smsLogin, setSmsLogin, resendCode} = props;
  const [showPasswordField, setShowPasswordField] = useState(false);
  
  return (
    <Formik
      onSubmit={values => {
        values.email = formatPhone(values.email);
        onSubmit(values);
      }}
      initialValues={initialValues}
      validate={(values)=>validate(values, setShowPasswordField, setSmsLogin)}
    >
      <Form>
        {failAuth && <Alert color="danger">{failAuth}</Alert>}
        {smsLogin&&(<Field
          innerRef={input => (inputs.email = input)}
          onKeyPress={focusNextField("password")}
          name="email"
          type="text"
          component={TextInput}
          placeholder="Email or Phone Number"
          label="Email Or Phone Number"
          autocapitalize="none"
          disabled
        />)}
        {!smsLogin&&(<Field
          innerRef={input => (inputs.email = input)}
          onKeyPress={focusNextField("password")}
          name="email"
          type="text"
          component={TextInput}
          placeholder="Email or Phone Number"
          label="Email Or Phone Number"
          autocapitalize="none"
        />)}
        {showPasswordField &&(<Field
          innerRef={input => (inputs.password = input)}
          name="password"
          type="password"
          component={TextInput}
          placeholder="Password"
          label="Password"
        />)}
        {smsLogin &&(<Field
          innerRef={input => (inputs.password = input)}
          name="verification_code"
          type="text"
          component={TextInput}
          placeholder="Verification code"
          label="Verification Code"
        />)}
        <div className="text-center">
          <Button
            type="submit"
            color="info"
            fill
            block
          >
          {!smsLogin &&(<Fragment> 
              Login{" "}
            <FontAwesomeIcon style={{ marginLeft: 10 }} icon={faPowerOff} />
           </Fragment>)}
            {smsLogin &&(<Fragment>Submit</Fragment>)}
          </Button>
          {smsLogin && <p onClick={resendCode} style={{color: '#00c7a5', cursor: 'pointer'}}>Resend Code</p>}
        </div>
      </Form>
    </Formik>
  );
};

LoginForm.propTypes = {
  onSubmit: PropTypes.func.isRequired,
  authenticating: PropTypes.bool.isRequired,
  failAuth: PropTypes.string
};

export const validate = (values = {}, setShowPasswordField, setSmsLogin) => {
  const errors = {};
  if (!values.email) {
    errors.email = "Required";
  }
  
  if (values.email.includes("@")) {
    setShowPasswordField(true);
    if (!values.password) {
      errors.password = "Required";
    }
  }else{
    setShowPasswordField(false);
  }
  // if (values.sid) {
  //   setSmsLogin(true);
  // }
  return errors;
};

export default compose(
  setDisplayName("LoginForm"),
  NextForm
)(LoginForm);
